import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ModalWindowWrapper } from '../../models';
import { IS_MOBILE_TOKEN } from '@anecdotes/design-system/injection-tokens';

@Component({
  selector: 'app-central-modal',
  templateUrl: './central-modal.component.html',
  styleUrls: ['./central-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CentralModalComponent {
  @Input()
  modalWindowWrapper: ModalWindowWrapper;

  @Output()
  closeModal = new EventEmitter<void>();

  get isCloseBtnDisplayed(): boolean {
    // undefined is not equal to false, so undefined for options object fields means that user didn't provide this option and undefined used as default value.
    return this.modalWindowWrapper.modalWindow.options?.closeBtnDisplay !== false;
  }

  constructor(@Inject(IS_MOBILE_TOKEN) readonly isMobile: boolean) {}
}
